// Call plugin.
import * as actionTypes from '../actionTypes'

/**
 * Represents that TURN information has changed.
 * @method turnChanged
 * @return {Object}
 */
export function turnChanged ({ servers, credentials }) {
  return {
    type: actionTypes.TURN_CHANGED,
    payload: {
      servers,
      credentials
    }
  }
}
